export const UPDATE_OVERTIME_REQUEST_PENDING =
  'UPDATE_OVERTIME_REQUEST_PENDING';
export const UPDATE_OVERTIME_REQUEST_ERROR = 'UPDATE_OVERTIME_REQUEST_ERROR';
export const UPDATE_OVERTIME_REQUEST_SUCCESS =
  'UPDATE_OVERTIME_REQUEST_SUCCESS';
export const SET_UPDATE_OVERTIME_REQUEST_FORM_INITIAL_STATE =
  'SET_UPDATE_OVERTIME_REQUEST_FORM_INITIAL_STATE';

export const UPDATE_TIME_ADJUSTMENT_REQUEST_PENDING =
  'UPDATE_TIME_ADJUSTMENT_REQUEST_PENDING';
export const UPDATE_TIME_ADJUSTMENT_REQUEST_ERROR =
  'UPDATE_TIME_ADJUSTMENT_REQUEST_ERROR';
export const UPDATE_TIME_ADJUSTMENT_REQUEST_SUCCESS =
  'UPDATE_TIME_ADJUSTMENT_REQUEST_SUCCESS';
export const SET_UPDATE_TIME_ADJUSTMENT_REQUEST_FORM_INITIAL_STATE =
  'SET_UPDATE_TIME_ADJUSTMENT_REQUEST_INITIAL_STATE';

export const OPEN_OVERTIME_REQUEST_MODAL = 'OPEN_OVERTIME_REQUEST_MODAL';
export const CLOSE_OVERTIME_REQUEST_MODAL = 'CLOSE_OVERTIME_REQUEST_MODAL';
export const OPEN_TIME_ADJUSTMENT_REQUEST_MODAL =
  'OPEN_TIME_ADJUSTMENT_REQUEST_MODAL';
export const CLOSE_TIME_ADJUSTMENT_REQUEST_MODAL =
  'CLOSE_TIME_ADJUSTMENT_REQUEST_MODAL';
